document.addEventListener("DOMContentLoaded", function () {
  // --- Variant Select Update ---
  const select = document.getElementById("variant-select");
  const mapping = {
    ".product-specification": "data-specification",
    ".description-content-ability": "data-long_description",
    ".delivery-and-setup": "data-delivery-setup",
    ".product-faq": "data-faq",
    ".standard-call-to-action": "data-standard_call_to_action",
    ".cs-short-description": "data-delivery-short_description",
  };
  function updateContent(option) {
    Object.entries(mapping).forEach(([selector, attr]) => {
      const value = option.getAttribute(attr);
      if (value) document.querySelector(selector).innerHTML = value;
    });
  }
  const initialOption = select.querySelector("option[selected]") || select.options[0];
  updateContent(initialOption);
  document.querySelectorAll(".productOption").forEach((el, idx) => {
    el.addEventListener("click", () => updateContent(select.options[idx]));
  });

  // --- Predictive Search ---
  const searchInput = document.getElementById("Search-In-Templates");
  const resultsDiv = document.querySelector(".predictive-search--results-body");
  searchInput.addEventListener("input", () => {
    resultsDiv.classList.toggle("cs-result-active", searchInput.value.trim() !== "");
  });

  // --- Hide Empty Accordions ---
  document.querySelectorAll(".product-accordion").forEach(acc => {
    if (!acc.querySelector(".product-accordion--content-body").textContent.trim()) acc.style.display = "none";
  });

  // --- Video Play/Pause ---
  const video = document.getElementById("video");
  const playBtn = document.getElementById("circle-play-b");
  playBtn.addEventListener("click", () => {
    video.paused || video.ended ? video.play() : video.pause();
  });
  video.addEventListener("playing", () => { playBtn.style.opacity = 0; playBtn.style.pointerEvents = "none"; });
  video.addEventListener("pause", () => { playBtn.style.opacity = 1; playBtn.style.pointerEvents = "auto"; });

  // --- Fancybox ---
  if (typeof Fancybox !== "undefined") {
    Fancybox.bind("[data-fancybox='gallery']", {
      Thumbs: { autoStart: true },
      Toolbar: { display: ["close"] },
      zoom: { wheel: "auto" },
    });
  }
});

$(function () {
  // --- Slider Initialization ---
  const initSlick = (selector, settings) => $(selector).slick(settings);

  // Testimonial Slider
  initSlick(".cs-testimonial-slider", {
    dots: false, arrows: false, infinite: true, speed: 500,
    slidesToShow: 1, slidesToScroll: 1, autoplay: true, autoplaySpeed: 2000
  });
  $(document).on("click", ".testimonial-swiper-button-prev", () => $(".cs-testimonial-slider").slick("slickPrev"));
  $(document).on("click", ".testimonial-swiper-button-next", () => $(".cs-testimonial-slider").slick("slickNext"));
  $(".cs-testimonial-slider").on("beforeChange", (e, slick) => $(slick.$slides).find(":focus").blur());

  // Mobile Slider
  initSlick(".mobile-slide", {
    dots: false, arrows: false, infinite: true, speed: 500,
    slidesToShow: 1, slidesToScroll: 1, autoplay: true, autoplaySpeed: 3000
  });
  $(".swiper-button-prevs").click(() => $(".is-slider").slick("slickPrev"));
  $(".swiper-button-nexts").click(() => $(".is-slider").slick("slickNext"));

  // Gallery Slider
  const $mainSlider = $(".gallery-slider");
  const $thumbSlider = $(".gallery-thumbs");
  const gallerySettings = {
    slidesToShow: 1, slidesToScroll: 1, arrows: false, fade: true, asNavFor: ".gallery-thumbs"
  };
  const thumbSettings = {
    slidesToShow: 3, slidesToScroll: 1, asNavFor: ".gallery-slider",
    dots: false, centerMode: true, focusOnSelect: true, variableWidth: true,
    prevArrow: $(".cs-swiper-button-prev"), nextArrow: $(".cs-swiper-button-next")
  };
  $mainSlider.not(".slick-initialized").slick(gallerySettings);
  $thumbSlider.not(".slick-initialized").slick(thumbSettings);

  // Synchronize active slide after init
  setTimeout(() => {
    const $active = $mainSlider.find(".gallery-image.active").first();
    if ($active.length) {
      const idx = $active.data("slick-index") ?? $mainSlider.find(".gallery-image").index($active);
      $mainSlider.slick("slickGoTo", idx);
      $thumbSlider.slick("slickGoTo", idx);
    }
  }, 200);
});

/* ============================================================
   Slideshow rail thumb — slides the active-segment bar along the
   pagination rail instead of cross-fading between segments.
   Pairs with the "Sliding rail thumb" block in slideshow.css.

   Only sets two custom properties (--rail-count / --rail-index)
   and one class on the pagination; all geometry is CSS maths, so
   there is no resize handling to do. Without JS the per-segment
   fade in slideshow.css remains as the fallback indicator.

   IMPORTANT: writes are change-guarded and there is deliberately
   NO paginationRender hook. The theme's swiper-content runs
   Swiper with a mutation observer, so an unconditional style
   write inside a render callback livelocks:
   setProperty -> observer -> swiper.update() -> paginationRender
   -> setProperty -> ... The container's ::after survives bullet
   re-renders anyway, so slideChange alone is sufficient.
   ============================================================ */
(function () {
  'use strict';
  if (window.__railSlideInit) return;
  window.__railSlideInit = true;

  function attach(outer) {
    var pag = outer.querySelector('.swiper-pagination');
    if (!pag || pag.dataset.railReady === 'true') return;

    function bind() {
      var sw = outer.swiper;
      if (!sw) return false;

      var lastCount = null;
      var lastIndex = null;
      function update() {
        var count = pag.querySelectorAll('.swiper-pagination-bullet').length || 1;
        var index = sw.realIndex || 0;
        /* change-guarded: identical setAttribute still fires
           MutationObserver, which would re-trigger swiper.update() */
        if (count !== lastCount) {
          lastCount = count;
          pag.style.setProperty('--rail-count', count);
        }
        if (index !== lastIndex) {
          lastIndex = index;
          pag.style.setProperty('--rail-index', index);
        }
      }

      update(); /* position BEFORE revealing — the thumb fades in already in place */
      pag.dataset.railReady = 'true';
      pag.classList.add('rail-slide-ready');
      sw.on('slideChange', update);
      return true;
    }

    /* the theme's swiper-content element initialises Swiper after
       DOMContentLoaded; poll briefly until the instance exists */
    if (!bind()) {
      var tries = 0;
      var t = setInterval(function () {
        if (bind() || ++tries > 50) clearInterval(t);
      }, 100);
    }
  }

  function initAll() {
    document.querySelectorAll('.slideshow--outer.navigation-dots.swiper').forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
